import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../../ExchangeCB/Loader";
import StatusBadge from "../../common/StatusBadge/StatusBadge";
import { formatPhoneNumber } from "../../../helpers/getDisplayValue.helpers";
import NoResultsComponent from "../../common/NoResults/NoResults";
import "./requestListTable.scss";
import {RequestStatus, requestStatus} from "../../../constants/constants";

const RequestListTable = ({ data, match }) => {
  const { loading } = useSelector(({ autolombard }) => autolombard.requests);
  const isNewStatus = (status) => status === RequestStatus.CREATED.key;

  if(!data.length) {
    return <NoResultsComponent/>
  }

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Заявка</th>
          <th>Физ.лицо</th>
          <th>Желаемая сумма</th>
          <th>Срок</th>
          <th>Оценочная стоимость</th>
          <th>Номер телефона</th>
          <th>Статус</th>
        </tr>
      </thead>
      {loading ? (
            <Loader pageRange={1} />
          ) : <tbody>
        {data.map(
          ({
            id,
            status,
            name,
            person,
            desiredAmount,
            term,
            interest,
            phone,
          }) => {
            const { label, key } = requestStatus.find((s) => s.key === status);
            return (
              <tr key={id} className={isNewStatus(status) ? "new" : undefined}>
                <td>
                  <div className="d-flex flex-row align-center">
                    {isNewStatus(status) && (
                      <div>
                        <span className="status-circle"></span>
                      </div>
                    )}
                    <Link className="request-link" to={`${match.url}/${id}`}>
                      <span>{name}</span>
                    </Link>
                  </div>
                </td>
                <td>{person}</td>
                <td className="nowrap">
                  {Intl.NumberFormat("ru-RU").format(desiredAmount)} BYN
                </td>
                <td className="nowrap">{term}</td>
                <td className="nowrap text-center">{interest}</td>
                <td className="nowrap">{formatPhoneNumber(phone)}</td>
                <td>
                  <StatusBadge children={label} status={key} />
                </td>
              </tr>
            );
          }
        )}
      </tbody>}
    </table>
  );
};

export default RequestListTable;
